import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { pluck, map, exhaustMap } from 'rxjs/operators';
import { CompanyActions } from '../actions/company.actions';
import { CompanyService } from '../../services/company.service';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';

@Injectable()
export class CompanyEffects {
  $loadCompany = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.COMPANY_LOAD_COMPANY),
      exhaustMap((action: { name: string; }) => { return this.loadCompany(action.name) }),
    ),
  );

  private loadCompany(name: string): Observable<Action> {
    return this.companyService.getCompany(name).pipe(
      pluck('body'),
      map(res => ({
        type: CompanyActions.COMPANY_LOAD_COMPANY_SUCCESS,
        payload: { company: res },
      })),
    );
  }

  $loadCompanyIntegration = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.COMPANY_LOAD_COMPANY_INTEGRATION),
      exhaustMap((action: { name: string; }) => { 
        return this.loadCompanyIntegration(action.name) 
      }),
    ),
  );

  private loadCompanyIntegration(name: string): Observable<Action> {
    return this.companyService.getCompanyIntegration(name).pipe(
      pluck('body'),
      map(res => ({
        type: CompanyActions.COMPANY_LOAD_COMPANY_INTEGRATION_SUCCESS,
        payload: { companyIntegration: res },
      })),
    );
  }

  constructor(
    private actions$: Actions,
    private companyService: CompanyService,
  ) {}
}
